import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

export default function BarChartsStatus(props) {

  return (
    <div>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer>

          <BarChart
            width={900}
            height={300}
            data={props.dataChart}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey={"Atentdidos"} fill="green" />
            <Bar dataKey={"Canceladas"} fill="red" />
            <Bar dataKey={"Perdidos"} fill="orange" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
